export enum UserRole {
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  OWNER = 'Owner',
}
